import styled from "styled-components";
import { Form as ANTDForm, Row, Col } from "antd";

export const ModalSpamTitle = styled.span`
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #6c7485;
`;

export const ModalForm = styled(ANTDForm)`
    margin-top: 6px;
`;

export const ScreenActions = styled(Row)`
    display: flex;
    transition: all ease 0.4s;
`;

export const BoxFields = styled(Col)`
    display: flex;
    flex-wrap: wrap;
`;

export const BoxButtons = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;